import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';

const Login = () => {
  const { t } = useTranslation();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [captchaQuestion, setCaptchaQuestion] = useState({ num1: 0, num2: 0 });
  const [captchaAnswer, setCaptchaAnswer] = useState('');

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    setCaptchaQuestion({ num1, num2 });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Check captcha
    const correctAnswer = captchaQuestion.num1 + captchaQuestion.num2;
    if (parseInt(captchaAnswer) !== correctAnswer) {
      toast.error('Грешен отговор на проверката. Опитайте отново.');
      generateCaptcha();
      setCaptchaAnswer('');
      return;
    }
    
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Успешен вход!');
      navigate('/dashboard');
    } catch (error) {
      toast.error('Грешка при вход. Проверете данните си.');
      generateCaptcha();
      setCaptchaAnswer('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container" data-testid="login-page">
      <div className="login-card">
        <div className="login-header">
          <img 
            src="https://customer-assets.emergentagent.com/job_6328ef84-4bcd-4029-8d62-7f91e39a9a93/artifacts/3vjif819_97c6b968ff444f522898e577c3b08e60.png" 
            alt="FleetFlow Logo" 
            className="login-logo"
          />
          <h1>FleetFlow</h1>
          <p>{t('login')}</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form" data-testid="login-form">
          <div className="form-group">
            <label>{t('email')}</label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="email-input"
            />
          </div>

          <div className="form-group">
            <label>{t('password')}</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="password-input"
            />
          </div>

          <div className="form-group captcha-group">
            <label>Проверка за сигурност</label>
            <div className="captcha-question">
              Колко е {captchaQuestion.num1} + {captchaQuestion.num2}?
            </div>
            <Input
              type="number"
              value={captchaAnswer}
              onChange={(e) => setCaptchaAnswer(e.target.value)}
              required
              placeholder="Въведете отговор"
              data-testid="captcha-input"
            />
          </div>

          <Button type="submit" disabled={loading} className="login-button" data-testid="login-submit-btn">
            {loading ? 'Вход...' : t('login')}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
